var mp = mp || {};

// Init Selectric
//-----------------------------------------------------------------
mp.selectric = function() {
    var $trigger = $('.form--select');

    if (!$trigger.length) {
        return;
    }

    $trigger.selectric({
        disableOnMobile: false,
        nativeOnMobile: true,
    });
}

// Litebox
//-----------------------------------------------------------------
mp.fancyBox = function() {
    var $trigger = $("[data-fancybox]");

    if (!$trigger.length) {
        return;
    }
    
    $trigger.fancybox({
		thumbs: false,
		fullScreen : false,
		hash: false,
        buttons: [
            "close"
        ],
        afterLoad: function(){
            //$('.form--select').selectric('refresh');
        },
	});
};


// Background image holder
//-----------------------------------------------------------------
mp.backgroundHolder = function() {
    var $element = $(".background-holder");

    if (!$element.length) {
        return;
    }

    $element.each(function(){
        var $img = $(this).find('img');
        var $imageSrc = $img.attr('src');
        $img.remove();
        $(this).css('background-image', 'url('+$imageSrc+')').addClass('show');
    });
};



// Loading overlay
//-----------------------------------------------------------------
mp.loadingOverlay = function($action) {
    $html = '<div class="loader"><div class="spinner"></div></div>';

    if ($action == "show") {
        $('body').append($html);
    } else {
        $('.loader').remove();
    }
};





// Fit Vids
//-----------------------------------------------------------------
mp.fitVids = function() {
    var $element = $(".wysiwyg");

    if (!$element.length) {
        return;
    }

    $element.fitVids();
};





$(document).ready(function (){
    mp.fancyBox();
    mp.backgroundHolder();
    mp.selectric();
    mp.fitVids();
});